import React, {FC} from 'react';

import {
  MessageErrorModel,
  MessageErrorsEnum,
} from '../../../../../../../libs/shared/core/src/models/api/messageErrorModel';
import {UserThemeConsumer} from '../../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {MessageBanner} from './messageBanner';
import {MessageBannerTitle} from './messageBannerTitle';

/*
 * Props.
 */

interface ImportMessageFailedBannerProps {
  error: MessageErrorModel;
  isRounded: boolean;
}

/*
 * Component.
 */

export const ImportMessageFailedBanner: FC<ImportMessageFailedBannerProps> = (props) => {
  const {error} = props;
  const errorMessage = computeTitleErrorMessage(error);

  if (!errorMessage) {
    return null;
  }

  return (
    <UserThemeConsumer>
      {(theme) => (
        <MessageBanner
          color={theme.palette.yellow.shade40}
          iconName="warningFilledSmall"
          isRounded={props.isRounded}
        >
          <MessageBannerTitle>{errorMessage}</MessageBannerTitle>
        </MessageBanner>
      )}
    </UserThemeConsumer>
  );
};

/*
 * Helpers.
 */

function computeTitleErrorMessage(error: MessageErrorModel) {
  switch (error.type) {
    case MessageErrorsEnum.IMPORT_ATTACHMENT_FAILURE:
    case MessageErrorsEnum.O365_ATTACHMENT_FAILURE:
      return error.description;
    default:
      return null;
  }
}
